import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useLocation } from 'react-router';
import { PATHS } from '~fpu/config/constants';

interface Data {
  data: boolean;
}

function fetchHasFpuAllAccess() {
  return axios.get(PATHS.API.USER_HAS_FPU_ALL_ACCESS);
}

function useHasFpuAllAccess() {
  const { pathname } = useLocation();
  return useQuery({
    queryKey: ['has-fpu-all-access'],
    queryFn: () => fetchHasFpuAllAccess(),
    select: (data: Data) => data.data,
    retry: false,
    refetchOnWindowFocus: true,
    enabled: !pathname.startsWith(PATHS.ADMIN.BASE)
  });
}

export { useHasFpuAllAccess };
